export default "/kiban/_next/static/images/warning-c60c7843ca3cdb0bcf63d4b9fb6db9de.svg";